const MODULE_NAME = 'axp-consumer-travel-root';

export default MODULE_NAME;
